export interface SelectItemDTO {
  label: string;
  value: string;
  parentId?: string;
}
